module.exports = __webpack_public_path__ + "odinstatic/media/cms-panel-active.c8b37189.svg";